<template>
  <v-dialog value="true" fullscreen scrollable :transition="false">
    <v-container fluid class="fill-height white">
      <v-row class="fill-height">
        <template v-if="loaded">
          <template v-if="!session.finished">
            <v-container>
              <v-card>
                <v-toolbar class="primary tile" dark dense flat tile extended>
                  <v-toolbar-title>
                    &laquo;{{ test.name }}&raquo;
                  </v-toolbar-title>
                  <v-spacer />
                  <v-row class="px-3" slot="extension">
                    <v-toolbar-title>
                      Идет тетсирование. Вопрос {{ answer.pos }} из
                      {{ session.count }}
                    </v-toolbar-title>
                    <v-spacer />
                    <v-toolbar-title>
                      <Timer :session="session" :test="test" @timeout="post" />
                    </v-toolbar-title>
                  </v-row>
                </v-toolbar>
                <v-card-text>
                  <Question v-model="choice" :question="question" />
                </v-card-text>
                <v-card-actions>
                  <v-btn
                    class="very-wide"
                    color="primary"
                    @click="answerIfReady"
                  >
                    Ответить
                  </v-btn>
                  <v-spacer />
                  <v-btn @click="skip">
                    Отложить
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-container>
          </template>
          <template v-else>
            <v-container>
              <v-card>
                <v-card-text>
                  <h1 class="display-3">Итоги тестирования</h1>
                  <Report
                    :session="session"
                    :test="test"
                    :report="report"
                    :achievements="achievements"
                  />
                </v-card-text>
                <v-card-actions>
                  <v-btn block color="primary" :to="{ name: 'tests' }">
                    Назад
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-container>
          </template>
        </template>
        <template v-else>
          <v-container>
            <v-skeleton-loader
              class="mt-4"
              loading
              tile
              type="table-heading, paragraph, button"
            ></v-skeleton-loader>
          </v-container>
        </template>
      </v-row>
    </v-container>
  </v-dialog>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import Timer from '../components/Testing/Timer'
import Question from '../components/Testing/Question'
import Report from '../components/Testing/Report'
export default {
  name: 'Session',
  components: {
    Timer,
    Question,
    Report
  },
  data() {
    return {
      loaded: false,
      session: {},
      test: {},
      answer: {},
      question: {},
      choice: '',
      report: {},
      achievements: []
    }
  },
  mounted() {
    this.fetch()
  },
  methods: {
    parse(body) {
      const {
        test,
        session,
        answer,
        question,
        report,
        achievements
      } = body.data
      this.test = test
      this.session = session
      this.answer = answer
      this.question = question
      this.report = report || {}
      this.achievements = achievements || []
      this.choice = ''
      if (this.question && this.question.type === 2) {
        this.choice = this.question.items.map((e, index) => index + 1).join(',')
      }
      if (this.question && this.question.type === 3) {
        this.choice = this.question.matches
          .map((e, index) => index + 1)
          .join(',')
      }
    },
    fetch() {
      this.request('/session/' + this.$route.params.id)
        .then(body => {
          this.parse(body)
          this.loaded = true
        })
        .catch(() => this.$router.push({ name: 'tests' }))
    },
    skip() {
      this.request({
        url: '/session/' + this.$route.params.id + '/' + this.question.id,
        method: 'post',
        data: {
          action: 'skip'
        }
      }).then(body => {
        this.parse(body)
        this.loaded = true
      })
    },
    answerIfReady() {
      if (!this.choice) {
        return this.message({
          text: 'Пожалуйста, дайте ответ на вопрос',
          color: 'error'
        })
      } else {
        this.post()
      }
    },
    post() {
      this.request({
        url: '/session/' + this.$route.params.id + '/' + this.question.id,
        method: 'post',
        data: {
          action: 'answer',
          choice: this.choice
        }
      }).then(body => {
        this.parse(body)
        this.loaded = true
      })
    },
    ...mapMutations(['message']),
    ...mapActions(['request'])
  }
}
</script>
<style scoped>
header {
  display: none !important;
}
footer {
  display: none !important;
}
</style>
<style scoped>
.tile {
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
.wide {
  min-width: 200px !important;
}
.very-wide {
  min-width: 300px !important;
}
</style>
